import './styles.scss';

const AddSeriesContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className="add-series-container">{children}</div>;
};

export default AddSeriesContainer;
